module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paginator"
  }, [_c('div', {
    staticClass: "paginator-body"
  }, [_vm._t("default", null, {
    data: _vm.data,
    pageNumber: _vm.pageNumber
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "paginator-footer",
    attrs: {
      "layout": "row center-justify"
    }
  }, [_c('div', {
    staticClass: "paginator-button paginator-page-previous",
    on: {
      "click": _vm.movePrevious
    }
  }, [_c('span', [_vm._v("←")])]), _vm._v(" "), _c('div', {
    staticClass: "paginator-page-numbers"
  }, _vm._l((_vm.pages.length), function(num) {
    return _c('div', {
      staticClass: "paginator-button paginator-page-number",
      class: {
        'active': num === _vm.pageNumber
      },
      on: {
        "click": function($event) {
          _vm.moveTo(num)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(num))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "paginator-button paginator-page-next",
    on: {
      "click": _vm.moveNext
    }
  }, [_c('span', [_vm._v("→")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66cb282c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paginator/paginator.vue
// module id = 2158
// module chunks = 0